import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperBackDrop: {
      color: theme.palette.text.primary,
      width: '490px',
    },
    circularProgressBackDrop: {
      marginBottom: '20px',
      marginLeft: '10px',
    },
    typographyBackdrop: {
      color: theme.palette.text.primary,
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: '#fff',
    },
  }),
);

export default useStyles;
